import { TabBar } from "@website/ui/tab-bar/tab-bar";
import { useTab } from "@website/ui/tabs/tab.hook";
import styles from "@website/ui/tabs/tabs.module.scss";
import { TabsPropertiesType } from "@website/ui/tabs/tabs.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const Tabs: FC<TabsPropertiesType> = (properties) => {
  const {
    className,
    orientation = "horizontal",
    behavior = "button",
    tabs,
    panel,
    panelContainerClassName
  } = properties;

  const { selectedTab, tabBarProperties } = useTab(properties);

  return (
    <div
      className={`${styles["tabs"]} ${styles[orientation]} ${className ?? ""}`}
    >
      <TabBar {...tabBarProperties} />
      <div
        className={`${styles["panels-container"]} ${panelContainerClassName}`}
      >
        {behavior === "link" || behavior === "custom" ? (
          <div className="" tabIndex={0}>
            {panel}
          </div>
        ) : (
          tabs.map((item, index) => (
            <div
              aria-labelledby={`tab-button-${index}`}
              className=""
              hidden={selectedTab !== index}
              id={`tab-${index}`}
              key={item.title}
              role="tabpanel"
              tabIndex={0}
            >
              {item.panel}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const TabsMemoized = memo(Tabs, deepCompare);
export { TabsMemoized as Tabs };
